module.exports = __webpack_public_path__ + "static/media/login.d548a1ad.png";